/**
 * Created by administrator on 2017/3/29.
 */
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from 'utils';
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue'; //添加幼儿园（原开课申请）

export default {
  components: {
    optOpenClassDialog
  },
  data() {
    return {
      selType: 1
    }
  },
  methods: {
    //添加幼儿园
    addSchool() {
      this.$refs.refoptOpenClassDialog.show({
        isAdd: true,
        SchoolCome: 0,
        isShowImg: true,
        isDefaultChecked: true, //平台开通申请表默认选中
        isRequired: true //平台开通申请必填
      })
    },
  },
  created() {

  }

}


// WEBPACK FOOTER //
// ./src/pages/school/AddSchool/vm.js